import { Button, Form, Input, Table } from 'antd';
import { Row } from 'antd';
import { Col } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import API from '../../services/api-service';
import queryString from 'query-string';
import { debounce } from 'lodash';
import dayjs from 'dayjs';

export default function CustomerListingPage() {
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [totalCustomer, setTotalCustomer] = useState(0);
  const [filters, setFilters] = useState({
    page: 1,
    pageSize: 10,
  });
  const [filterForm] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const search = useMemo(() => {
    return queryString.parse(location.search, {
      arrayFormat: 'comma',
    });
  }, [location]);
  const changeUrlQueryString = (filters: any) => {
    navigate(
      '/customers?' + queryString.stringify(filters, { arrayFormat: 'comma', skipEmptyString: true, skipNull: true }),
    );
  };

  const onTableChange = (pagination: any, tableFilters: any, sorter: any) => {
    const formValues = filterForm.getFieldsValue();
    const newFilters = {
      ...filters,
      ...tableFilters,
      page: pagination.current,
      pageSize: pagination.pageSize,
    };
    filters.page = pagination.current;
    filters.pageSize = pagination.pageSize;
    setFilters(newFilters);
    changeUrlQueryString(newFilters);
  };

  const onChangeFormFilter = (e: any) => {
    const formValues = filterForm.getFieldsValue();
    const newFilters = {
      ...filters,
      ...formValues,
      page: 1,
    };
    changeUrlQueryString(newFilters);
  };

  const onClearFilter = () => {
    filterForm.resetFields();
    setFilters({ page: 1, pageSize: 10 });
    changeUrlQueryString({ page: 1, pageSize: 10 });
  };

  const getCustomers = async (filters: any) => {
    setLoading(true);
    try {
      const response = await API.get('/api/customers', { params: filters });
      setCustomers(response.data.data);
      setTotalCustomer(response.data.total);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const onSearch = useCallback(
    debounce(filters => {
      getCustomers(filters);
    }, 500),
    [],
  );
  useEffect(() => {
    onSearch(filters);
  }, [filters]);
  useEffect(() => {
    const refinedFilters: any = {};
    Object.keys(search).forEach(key => {
      if (['phoneNumber', 'source'].includes(key) && search[key]) {
        if (Array.isArray(search[key])) {
          refinedFilters[key] = Object.values(search[key]!).map(x => +x!);
        } else {
          refinedFilters[key] = [+search[key]!];
        }
      } else if (key.indexOf('From') > 1 || key.indexOf('To') > 1) {
        try {
          refinedFilters[key] = dayjs(search[key] as string, 'YYYY-MM-DD');
        } catch (error) {
          console.log('ERROR', error);
        }
      } else {
        if (Array.isArray(search[key]))
          refinedFilters[key] = Object.values(search[key]!).map(x => (!isNaN(+x!) ? +x! : x));
        else {
          refinedFilters[key] = search[key];
        }
      }
      setFilters(refinedFilters);

      filterForm.setFieldsValue({
        ...refinedFilters,
      });
    });
  }, [search]);
  const tableColumns = [
    {
      title: 'Mã khách hàng',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      key: 'address',
      render: (text: string, record: any) => {
        return <div>{record.address}</div>;
      },
      ellipsis: true,
      width: 300,
    },
  ];
  return (
    <div className="md:p-8 sm:p-4 sm:pt-12">
      <Row gutter={[0, 32]} className="pb-6">
        <Col span={12}>
          <Link to={'/customers/entry'} className="mr-4">
            <Button size="large" type="primary">
              Tạo khách hàng mới
            </Button>
          </Link>
        </Col>
      </Row>
      <Form form={filterForm}>
        <Row gutter={[10, 32]} className="pb-6">
          <Col md={6} sm={12} xs={24}>
            <Form.Item name="keyword" className="mb-0">
              <Input placeholder="Tìm kiếm" />
            </Form.Item>
          </Col>
          <Col md={8} sm={8} xs={8}>
            <Form.Item noStyle className="mb-0 mr-2">
              <Button onClick={onChangeFormFilter} className="mr-2" loading={loading}>
                Lọc dữ liệu
              </Button>
            </Form.Item>
            <Form.Item noStyle className="mb-0">
              <Button onClick={onClearFilter} type="dashed" danger loading={loading}>
                Xóa lọc
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Table
        rowKey={'customerId'}
        dataSource={customers}
        pagination={{ total: totalCustomer, current: filters.page }}
        onChange={onTableChange}
        loading={loading}
        columns={tableColumns as any}
      />
    </div>
  );
}
